var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0955 20.0198C26.8462 20.0198 28.2655 18.6006 28.2655 16.8498C28.2655 15.0991 26.8462 13.6799 25.0955 13.6799C23.3448 13.6799 21.9255 15.0991 21.9255 16.8498C21.9255 18.6006 23.3448 20.0198 25.0955 20.0198Z",
    fill: "#EE702E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1498 13.6277C21.9388 13.6277 23.9567 11.1173 24.1485 7.79276C24.1565 7.64509 24.1605 7.50142 24.1605 7.35375C24.1605 3.42656 21.7111 1 17.7912 1H2L4.98083 4.30059H17.6034C19.6772 4.30059 20.7241 5.42608 20.7241 7.35375C20.7241 9.25349 19.6772 10.4069 17.6034 10.4069H16.085L18.914 13.6277H19.1498Z",
    fill: "#EE702E",
    stroke: "#EE702E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4262 19.9695H17.6992L6.28735 6.47974H11.0103L22.4262 19.9695Z",
    fill: "#1F6463",
    stroke: "#1F6463"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41535 20.71H9.48883C10.0741 20.71 10.4594 20.2871 10.6079 19.8608C10.7575 19.4318 10.7179 18.8848 10.3644 18.4658C10.3641 18.4655 10.3639 18.4652 10.3636 18.4649L6.29261 13.6059C6.29241 13.6057 6.29222 13.6055 6.29202 13.6052C5.92215 13.1614 5.37265 13.0761 4.92621 13.2975C4.49853 13.5096 4.21704 13.9713 4.21704 14.5139V19.3758C4.21704 20.0231 4.67625 20.71 5.41535 20.71Z",
    fill: "#EE702E",
    stroke: "#EE702E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/R.2734cd287393daaab184eabf23fc5417.svg";
export { ForwardRef as ReactComponent };